import type { FindFn } from "@shared/models/analytics/base"
import { createBlankEvent } from "@shared/models/analytics/base"
import type { LessonView } from "@shared/models/analytics/lesson"
import { getPossessiveForPlanbook } from "@shared/models/analytics/planbook"
import type { PreparedAction } from "../../action-doc-builder"
import { partial } from "lodash-es"
import type { Narrative } from "../create-narrative"
import defaultLessonActivity from "./default-lesson-activity"
import defaultLessonContext from "./default-lesson-context"
import defaultLessonModels from "./default-lesson-models"

interface Payload {
  cardStackId: string
  planbookId: string
  courseId: string
}

export default function lessonViewHistoryActioon(payload: Payload): PreparedAction {
  return {
    name: "LESSON_VIEW_HISTORY",
    payload: payload,
    patches: null,
    undoPatches: null,
    narrative: partial(narrative, payload),
  }
}

function narrative(payload: Payload, findFn: FindFn, userId): Narrative {
  let models = defaultLessonModels(payload, findFn, userId)
  let context = defaultLessonContext(payload, models)
  let newEvent: LessonView = {
    ...createBlankEvent(),
    root_id: payload.planbookId,
    root_type: "planbook",
    date_plan_scheduled_for: models.dateStringForCardStack,
    primary_object_id: payload.cardStackId,
    primary_object_id_and_ancestor_ids: models.cardStackIdAndAncestorIds,

    primary_verb: "view",
    primary_possessive: getPossessiveForPlanbook(findFn, userId, models.planbook?.id),
    primary_object_type: "lesson",
    primary_object_specifier: "history",
  }

  return {
    title: "Viewing Lesson History",
    titleForAnalytics: "Lesson - View History",
    description: `Viewing history for the lesson: ${models.cardStack?.attributes.title} in the course: ${models.course?.attributes.title}`,
    activity: defaultLessonActivity(payload, models),
    context: context,
    newAnalyticsEvents: [newEvent],
  }
}
